module.exports = __webpack_public_path__ + "media/src/images/page01_sub_001_zu02-3f0460e2868340de093eca44575b6484.gif";